import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Sheet, SheetContent, SheetDescription, SheetFooter, SheetHeader, SheetTitle, SheetTrigger } from '@/components/ui/sheet';
import { getLabelValue } from '@/utils/getLabelValue';
import { SlidersHorizontal } from 'lucide-react';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

type FilterAndSearchProps = {
  searchKey: string;
  setSearchKey: (value: string) => void;
  selectedStatus: string | null;
  setSelectedStatus: (status: string | null) => void;
};

export function FilterAndSearch({ searchKey, setSearchKey, selectedStatus, setSelectedStatus }: FilterAndSearchProps) {
  const [tempStatus, setTempStatus] = useState<string | null>(selectedStatus);
  const [sheetOpen, setSheetOpen] = useState(false);
  const [, setSearchParams] = useSearchParams();

  useEffect(() => {
    setTempStatus(selectedStatus);
  }, [selectedStatus]);

  const statusOptions = [
    { value: 'arrived', label: 'Anlänt' },
    { value: 'exited', label: 'Utpasserade' },
    { value: 'notArrived', label: 'Ej anlänt' },
    { value: 'onsite', label: 'På plats' },
    { value: 'cancelled', label: 'Avbokade' },
  ];

  const toggleStatus = (status: string) => {
    setTempStatus(prev => (prev === status ? null : status));
  };

  const applyFilters = () => {
    setSelectedStatus(tempStatus);
    setSheetOpen(false);
    setSearchParams(tempStatus ? { status: tempStatus } : {});
  };

  const clearFilters = () => {
    setTempStatus(null);
    setSelectedStatus(null);
    setSheetOpen(false);
    setSearchParams({});
  };
  return (
    <div className="flex flex-row gap-2">
      <Input placeholder={getLabelValue('SearchAttendees')} value={searchKey} onChange={e => setSearchKey(e.target.value)} className="w-full" />
      <Sheet open={sheetOpen} onOpenChange={setSheetOpen}>
        <SheetTrigger asChild>
          <Button variant="ghost" className="flex gap-2 relative">
            <SlidersHorizontal className="h-4 w-4" />
            {selectedStatus && (
              <Badge variant="default" className="absolute -top-2 -right-2 h-5 min-w-5 flex items-center justify-center px-1.5">
                1
              </Badge>
            )}
          </Button>
        </SheetTrigger>
        <SheetContent className="flex flex-col min-h-full px-4">
          <SheetHeader>
            <SheetTitle className='text-left'>{getLabelValue('FilterOnTitle')}</SheetTitle>
          </SheetHeader>
          <SheetDescription className="text-muted-foreground">{getLabelValue('FilterOnDescription')}</SheetDescription>

          <div className="flex flex-wrap gap-2 py-4">
            {statusOptions.map(option => (
              <Badge key={option.value} variant={tempStatus?.includes(option.value) ? 'default' : 'outline'} className="cursor-pointer text-sm py-1.5 px-3" onClick={() => toggleStatus(option.value)}>
                {option.label}
              </Badge>
            ))}
          </div>
          <SheetFooter className="mt-auto flex flex-col gap-2">
            <Button variant="outline" onClick={clearFilters}>
              {getLabelValue('ClearFilters')}
            </Button>
            <Button className="w-full" onClick={applyFilters}>
              {getLabelValue('ApplyFilter')}
            </Button>
          </SheetFooter>
        </SheetContent>
      </Sheet>
    </div>
  );
}
